export {};

$(document).on('click', '.js-remove-action', function onClick(evt) {
    //evt.preventDefault();

    const $action = $(this);
    const $rowForm = $action.closest('.row--form');
    const $formSection = $action.closest('.form-section');
    const $inputs = $rowForm.find('input');
    const $selects = $rowForm.find('select');

    const closestSelector = $action.data('closest');
    const targetSelector = $action.data('target');

    let $target;

    if (targetSelector) {
        $target = $(targetSelector);
    } else if (closestSelector) {
        $target = $action.closest(closestSelector);
    }

    if ($target) {
        $target.addClass('animated zoomOut');
        $inputs.val('');
        $selects.val('');
        $selects.trigger('change');

        setTimeout(() => {
            $target.addClass('hidden').removeClass('animated fast pulse zoomOut');
        }, 300);

        evt.preventDefault();
    }

    $formSection.find('.js-add-template').removeClass('hidden');
});



// WEBPACK FOOTER //
// ./js/main/module/remove-action.js